import { OfferElementTypeDto } from '@/api/generated';

export type ProcessOfferSectionsTranslation = {
  action: {
    add: string;
    edit: string;
    explainMissing: string;
    explainMissingTooltip: string;
    skipped: string;
  };
  deleteDialog: {
    button: {
      cancel: string;
      delete: string;
    };
    content: string;
    title: string;
  };
  item: {
    name: string;
    price: string;
  };
  items: { title: string } & Record<OfferElementTypeDto, SectionTranslation>;
  noItems: string;
  totalPrice: string;
};

type SectionTranslation = {
  title: string;
};

export const processOfferSectionsTranslation: ProcessOfferSectionsTranslation = {
  action: {
    add: 'Dodaj',
    edit: 'Edytuj',
    explainMissing: 'Wyjaśnij brak',
    explainMissingTooltip:
      'Oferta nie ma tej pozycji. Dodaj ją albo zapisz, dlaczego tym razem jej nie potrzeba',
    skipped: 'Bez tej pozycji: {{reason}}',
  },
  deleteDialog: {
    button: {
      cancel: 'Anuluj',
      delete: 'Usuń',
    },
    content: 'Czy na pewno chcesz usunąć element?',
    title: 'Usuń element',
  },
  item: {
    name: 'Nazwa',
    price: 'Cena',
  },
  items: {
    [OfferElementTypeDto.Decoration]: {
      title: 'Dekoracje',
    },
    [OfferElementTypeDto.DishPackages]: {
      title: 'Zestawy',
    },
    [OfferElementTypeDto.DrinkPackages]: {
      title: 'Zestawy napojów',
    },
    [OfferElementTypeDto.Equipment]: {
      title: 'Sprzęt',
    },
    [OfferElementTypeDto.Service]: {
      title: 'Obsługa',
    },
    [OfferElementTypeDto.Transport]: {
      title: 'Transport',
    },
    title: 'Dodatkowe elementy oferty',
  },
  noItems: 'Brak pozycji',
  totalPrice: 'Łączna cena',
};
